// components
import { PATH_PAGE } from '../../routes/paths';
import Iconify from '../../components/Iconify';
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuConfig = [
  {
    title: 'ACCUEIL',
    icon: <Iconify icon={'eva:home-fill'} {...ICON_SIZE} />,
    path: '/',
    aside: '/assets/background/togo-flag-free-png-image.png',
    children: [
      {
        subheader: 'Accueil',
        items: [
          {
            title: "Présentation de l'Agence",
            path: PATH_PAGE.accueil.presentation,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_Presentation_de_l_agence.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Mot du Ministre',
            path: PATH_PAGE.accueil.mot_du_ministre,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_mot_du_ministre.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Actualités',
            path: PATH_PAGE.accueil.actualites,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_Actualite.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Mot du DGA',
            path: PATH_PAGE.accueil.mot_du_dga,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_mot_du_ministre.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "Charte de l'Investisseur",
            path: PATH_PAGE.accueil.charte_de_l_investisseur,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_Charte_de_l_investisseur.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Documents',
            path: PATH_PAGE.accueil.documents,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_document.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Communiqués',
            path: PATH_PAGE.accueil.communique,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_Communique.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Foire Aux Questions',
            path: PATH_PAGE.accueil.foire_aux_question,
            icon: (
              <SvgIconStyle src={`/assets/icons/navbar/icone_faq.png`} sx={{ width: 70, height: 70, color: 'black' }} />
            ),
          },
        ],
      },
    ],
  },

  {
    title: 'INVESTIR AU TOGO',
    icon: <Iconify icon={'ic:round-money'} {...ICON_SIZE} />,
    path: PATH_PAGE.investire_au_togo.r10_d_investir_au_togo,
    aside: '/assets/background/togo-flag-free-png-image.png',
    children: [
      {
        subheader: 'Investir au Togo',
        backgroud: '/assets/background/togo-flag-free-png-image.png',
        items: [
          {
            title: 'Pourquoi le Togo',
            path: PATH_PAGE.pourquoi_le_togo.le_togo_en_bref,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/pourqoui_le_togo.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          /*
           * Pages temporairement masquées du menu dans l'attente de leur validation.
           * {
           *   title: 'Vivre au Togo',
           *   path: PATH_PAGE.pourquoi_le_togo.vivre_au_togo,
           *   icon: <SvgIconStyle src={`/assets/icons/navbar/location.png`} sx={{ width: 70, height: 70, color: 'black' }} />,
           * },
           * {
           *   title: 'Travailler au Togo',
           *   path: PATH_PAGE.pourquoi_le_togo.travailler_au_togo,
           *   icon: <SvgIconStyle src={`/assets/icons/navbar/bag.png`} sx={{ width: 70, height: 70, color: 'black' }} />,
           * },
           * {
           *   title: 'Sites touristiques',
           *   path: PATH_PAGE.pourquoi_le_togo.site_touristiques,
           *   icon: <SvgIconStyle src={`/assets/icons/navbar/pic.png`} sx={{ width: 70, height: 70, color: 'black' }} />,
           * },
           */
          {
            title: 'Profil secteur',
            path: PATH_PAGE.investire_au_togo.profil_secteur,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/profil_secteur.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "10 raisons d'Investir au Togo",
            path: PATH_PAGE.investire_au_togo.r10_d_investir_au_togo,
            icon: (
              <SvgIconStyle src={`/assets/icons/navbar/10_raison.png`} sx={{ width: 70, height: 35, color: 'black' }} />
            ),
          },
          {
            title: "Le Guide de l'Investisseur",
            path: PATH_PAGE.investire_au_togo.le_guide_d_investisseur,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/guide_investisseur.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
        ],
      },
    ],
  },
  {
    title: 'ZONE FRANCHE',
    icon: <Iconify icon={'mdi:timezone'} {...ICON_SIZE} />,
    path: PATH_PAGE.zone_franche.zone_franche,
    aside: '/assets/background/togo-flag-free-png-image.png',
    children: [
      {
        subheader: 'Zone Franche',
        items: [
          {
            title: 'Présentation de la Zone Franche',
            path: PATH_PAGE.zone_franche.zone_franche,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Presentation_de_la_zone_franche.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "Secteurs et Conditions d'éligibilité",
            path: PATH_PAGE.zone_franche.cdts_d_iligibilites,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Secteurs_et_conditions_d_eligibilite.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Avantages accordés',
            path: PATH_PAGE.zone_franche.avantages_accordes,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Avantages_accordes_18.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "Procédure d'obtention d'agrément",
            path: PATH_PAGE.zone_franche.procedure_d_obtention_agrement,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Procédure_d_obtention_d_agrement.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Sociétés en activité',
            path: PATH_PAGE.zone_franche.socitetes_en_activite,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Sociétes_en_activite.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Statistiques',
            path: PATH_PAGE.zone_franche.statistique,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Statistique.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
        ],
      },
    ],
  },
  {
    title: 'CODE DES INVESTISSEMENTS',
    icon: <Iconify icon={'mdi:code-greater-than-or-equal'} {...ICON_SIZE} />,
    path: PATH_PAGE.code_des_investisseurs.code_des_investisseurs,
    aside: '/assets/background/togo-flag-free-png-image.png',
    children: [
      {
        subheader: 'Code des investisseurs',
        items: [
          {
            title: "Présentation du Code de l'investissement",
            path: PATH_PAGE.code_des_investisseurs.code_des_investisseurs,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_Presentation_du_code_des_investisseurs.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "Conditions d'éligibilité",
            path: PATH_PAGE.code_des_investisseurs.cdts_d_iligibilites,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_condition_d_eligibilite.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Secteurs éligibles',
            path: PATH_PAGE.code_des_investisseurs.secteurs_eligibles,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_Secteurs_eligibles.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Avantages accordés',
            path: PATH_PAGE.code_des_investisseurs.avantages_accordes,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_Avantages_accordes.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "Procédure d'obtention d'agrément",
            path: PATH_PAGE.code_des_investisseurs.procedure_d_obtention_agrement,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_procedures_d_obtention_d_agrement.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Entreprises en activité',
            path: PATH_PAGE.code_des_investisseurs.entreprises_en_activite,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Sociétes_en_activite.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: 'Statistiques',
            path: PATH_PAGE.code_des_investisseurs.statistique,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_statistique.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
        ],
      },
    ],
  },

  {
    title: 'GUICHET UNIQUE',
    disable: false,
    icon: <Iconify icon={'uis:process'} {...ICON_SIZE} />,
    path: PATH_PAGE.guichet_unique.guichet_unique,
    aside: '/assets/background/togo-flag-free-png-image.png',
    children: [
      {
        subheader: 'Guichet unique',
        items: [
          {
            title: "Portail de l'Investissement",
            path: 'https://investirautogo.tg/',
            external: true,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Portail_de_l_investissement.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "Guichet Unique de l'Investissement",
            path: PATH_PAGE.guichet_unique.guichet_unique_de_l_investissement,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/ic_Guichet_unique.svg`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
          {
            title: "Aperçu d'une procédure documentée",
            path: PATH_PAGE.guichet_unique.apercu_d_une_procedure_documentee,
            icon: (
              <SvgIconStyle
                src={`/assets/icons/navbar/icone_document.png`}
                sx={{ width: 70, height: 70, color: 'black' }}
              />
            ),
          },
        ],
      },
    ],
  },
];

const secondaryNav = [
  {
    title: 'ÉVÈNEMENTS',
    icon: <Iconify icon={'material-symbols:event-available'} {...ICON_SIZE} />,
    path: PATH_PAGE.evenement,
    bgcolor: 'green',
    color: 'common.white',
  },
  {
    title: 'CONTACTS',
    icon: <Iconify icon={'ic:baseline-perm-contact-calendar'} {...ICON_SIZE} />,
    path: PATH_PAGE.contact,
  },
];

export { menuConfig, secondaryNav };
